import React, { Component } from 'react'
import { Button, Popover, Position, Text, Tag,  Menu, MenuItem, Intent } from '@blueprintjs/core';
import { DateRangePicker } from "@blueprintjs/datetime";
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import ListPicker from 'components/ListPicker';
import SearchDateRangePicker from 'components/SearchDateRangePicker';
import ClientAutocomplete from 'components/ClientAutocomplete';
import TechnicianPicker from 'components/TechnicianPicker';
import moment from 'moment-timezone';
import { formatDateRange } from 'helpers/dateRange';
import SearchFiltersToolbar from 'components/SearchFiltersToolbar';
import SearchFiltersSearchButton from 'components/SearchFiltersSearchButton';
import Toast from 'helpers/toaster';

const options = [
  { label: 'Paid', value: 'paid', selected: false },
  { label: 'Unpaid', value: 'unpaid', selected: false }
];

const QuickbooksOptions = [
  { label: 'Pushed to Quickbooks', value: 'true', selected: false },
  { label: 'Not Pushed to Quickbooks', value: 'false', selected: false }
]

@inject('store', 'invoiceStore', 'viewStore','workReportStore') @observer
class Invoice extends Component {

  @observable startDate = null;
  @observable endDate = null;
  @observable selectedClient = '';

  @action
  onDateRangeChange(range) {
    let {
      props: {
        viewStore: {
          invoiceSearch
        }
      }
    } = this;
    this.props.viewStore.invoiceSearch = {
      ...invoiceSearch,
      where: {
        ...invoiceSearch.where,
        created_at: { 
          gte: moment(range[0]).startOf('day').unix(),
          lte: moment(range[1]).endOf('day').unix()
        }
      }
    }
    this.startDate = range[0];
    this.endDate = range[1];
    this.search()
  }

  dateRangePicker = () => {
    return (
      <DateRangePicker 
        value={[this.search.startDate, this.search.endDate]}
        formatDate={(d) => { return d.toDateString() }} 
        parseDate={(d) => { console.log(d); return new Date(d) }}
        allowSingleDayRange={true}
        onChange={this.onDateRangeChange.bind(this)}
      />
    )
  }

  download_bulk_excel() {
    this.props.workReportStore.download_bulk_excel(this.props.viewStore.invoiceSearch)
  }

  download_bulk_pdf() {
    this.props.workReportStore.download_bulk_pdf(this.props.viewStore.invoiceSearch)
      .then(this.onSuccessfullGenerate.bind(this))
      .catch((error) => {})
  }

  onSuccessfullGenerate(response) {
    Toast.show({ icon: 'thumbs-up', message: response.data.message, intent: Intent.SUCCESS })
  }

  renderSelectedLocation = () => {
    if (this.search.location) {
      return <Text ellipsize={true} style={{ width: '250px' }}>{this.search.location}</Text>
    } else {
      return 'Location';
    }
  }

  @action
  onInvoiceStatusChange(selections) {
    let selectedValues = selections.map((status) => status.value);
    let {
      props: {
        viewStore: {
          invoiceSearch
        }
      }
    } = this;
    this.props.viewStore.invoiceSearch = {
      ...invoiceSearch,
      where: {
        ...invoiceSearch.where,
        payment_status: selectedValues
      }
    }
  }

  @action
  onInvoiceQuickbooksSyncStatusChange(selections) {
    let selectedValue = selections.map((status) => status.value)[0];
    let {
      props: {
        viewStore: {
          invoiceSearch
        }
      }
    } = this;
    this.props.viewStore.invoiceSearch = {
      ...invoiceSearch,
      where: {
        ...invoiceSearch.where,
        synced_with_quickbooks: selectedValue
      }
    }
  }

  onGrandTotalChange(e) {
    let {
      props: {
        viewStore: {
          invoiceSearch
        }
      }
    } = this;
    invoiceSearch.where.grand_total[e.target.id] = e.target.value;
  }

  @action
  onJobNumberChange(e) {
    let {
      props: {
        viewStore: {
          invoiceSearch
        }
      }
    } = this;
    this.props.viewStore.invoiceSearch = {
      ...invoiceSearch,
      where: {
        ...invoiceSearch.where,
        event_number: e.target.value
      }
    }
  }

  onEnter(event) {
    if (event.key === "Enter") {
      this.search()
    }
  }

  onServiceTypeChange(selections) {
    let selectedValues = selections.map((status) => status.value);
    let {
      props: {
        viewStore: {
          invoiceSearch
        }
      }
    } = this;
    this.props.viewStore.invoiceSearch = {
      ...invoiceSearch,
      where: {
        ...invoiceSearch.where,
        service_type_id: selectedValues
      }
    }
  }

  onTechnicianChange(technicians) {
    let selectedValues = technicians.map((status) => status.value);
    let {
      props: {
        viewStore: {
          invoiceSearch
        }
      }
    } = this;
    this.props.viewStore.invoiceSearch = {
      ...invoiceSearch,
      where: {
        ...invoiceSearch.where,
        created_by_id: selectedValues
      }
    }
  }

  @action
  onClientSelect(client) {
    let {
      props: {
        viewStore: {
          invoiceSearch,
          invoiceSearch: {
            where: {
              client_id,
              ...whereWithNoClientId
            }
          }
        }
      }
    } = this;
    if (client) {
      this.props.viewStore.invoiceSearch = {
        ...invoiceSearch,
        where: {
          ...invoiceSearch.where,
          client_id: client.id
        }
      }
    } else {
      this.props.viewStore.invoiceSearch = {
        ...invoiceSearch,
        where: {
          ...whereWithNoClientId
        }
      }
    }
  }

  @action
  search() {
    let viewStore = this.props.viewStore;
    viewStore.invoiceSearch.page = 1;
    viewStore.invoices();
  }

  render() {
    const {
      where
    } = this.props.viewStore.invoiceSearch;
    let startDate = moment.unix(parseInt(where.created_at.gte)).toDate();
    let endDate = moment.unix(parseInt(where.created_at.lte)).toDate();
    return (
      <SearchFiltersToolbar
        searchButton={
          <SearchFiltersSearchButton onClick={this.search.bind(this)} />
        }
        actions={
          <Popover
            minimal={true}
            content={
              <Menu>
                <MenuItem text="Download Excel/CSV" onClick={this.download_bulk_excel.bind(this)}/>
                <MenuItem text="Download PDF" onClick={this.download_bulk_pdf.bind(this)}/>
              </Menu>
            }
            position={Position.BOTTOM_LEFT}
            usePortal={true}>
            <Button rightIcon='caret-down'>
              Download Excel/CSV
            </Button>
          </Popover>
        }
      >
                <Popover
                  minimal={true}
                  content={
                    <SearchDateRangePicker
                      startDate={startDate}
                      endDate={endDate}
                      onChange={this.onDateRangeChange.bind(this)}
                    />
                  }
                  position={Position.BOTTOM_LEFT}
                  usePortal={true} >
                  <Button
                    className="filter-date"
                    icon="calendar"
                    rightIcon="caret-down"
                    text={formatDateRange(startDate, endDate)}
                  />
                </Popover>
                
                <ClientAutocomplete
                  selectedClientId={where && where.client_id}
                  onClientSelect={this.onClientSelect.bind(this)}
                />
                
                <TechnicianPicker
                  selectedOptions={(where && where.created_by_id) || []}
                  onChange={this.onTechnicianChange.bind(this)}
                  includeAdmins
                  showCreatedBy
                  includeSelectAll
                />
                
                <Popover
                  minimal={true}
                  content={
                    <ListPicker
                      selectedOptions={(where && where.payment_status) || []}
                      options={options}
                      onChange={this.onInvoiceStatusChange.bind(this)}
                    />
                  }
                  position={Position.BOTTOM_LEFT}
                  usePortal={true} >
                  <Button rightIcon='caret-down'>
                    Payment Status
                    <span>&nbsp;</span>
                    <Tag minimal={true} round={true}>{(where && where.payment_status && where.payment_status.length) || 0}</Tag>
                  </Button>
                </Popover>

                <Popover
                  minimal={true}
                  content={
                    <ListPicker
                      maximumSelections={1}
                      selectedOptions={(where && where.synced_with_quickbooks)}
                      options={QuickbooksOptions}
                      onChange={this.onInvoiceQuickbooksSyncStatusChange.bind(this)}
                    />
                  }
                  position={Position.BOTTOM_LEFT}
                  usePortal={true} >
                  <Button rightIcon='caret-down'>
                    Quickbooks
                    <span>&nbsp;</span>
                    <Tag minimal={true} round={true}>{(where && where.synced_with_quickbooks) ? 1 : 0}</Tag>
                  </Button>
                </Popover>

                <input
                  type="text"
                  className="bp3-input"
                  placeholder="Job or Invoice Number"
                  onChange={this.onJobNumberChange.bind(this)}
                  defaultValue={where.event_number}
                  onKeyPress={this.onEnter.bind(this)}
                />

                <div className="filter-bar__range">
                  <span className="filter-bar__range-label">Amount</span>
                  <input
                    id="gte"
                    type="text"
                    className="bp3-input"
                    placeholder="Min"
                    aria-label="Minimum amount"
                    onChange={this.onGrandTotalChange.bind(this)}
                    defaultValue={where.grand_total.gte}
                    onKeyPress={this.onEnter.bind(this)}
                  />
                  <span className="filter-bar__range-sep" aria-hidden="true">–</span>
                  <input
                    id="lte"
                    type="text"
                    className="bp3-input"
                    placeholder="Max"
                    aria-label="Maximum amount"
                    onChange={this.onGrandTotalChange.bind(this)}
                    defaultValue={where.grand_total.lte}
                    onKeyPress={this.onEnter.bind(this)}
                  />
                </div>
      </SearchFiltersToolbar>
    )
  }
}

export default Invoice;
